export class Address {
  // current address
  sAddrStreet: string;
  sAddrCity: string;
  sAddrState: string;
  sAddrZip: string;
  sAddrCountry: string;
  sCounty : string;
  sAddrType: number;
  sSearch: string;
  sResidencyType: number;
  sResidencyTypeDesc: string;
  sResidencyDuration: number;
  sRemarks = "";

  uiShow: boolean;
  uiArrow: string;
  uiExpanderText = "Expand";
  uiShowFlag : boolean;
}
